// for saving user state
export const SELECT_BROKER_NUMBER = 'SELECT_BROKER_NUMBER';
export const SELECT_VIEW_BY = 'SELECT_VIEW_BY';
export const SELECT_DATE_BY = 'SELECT_DATE_BY';
export const SELECT_CHART_TYPE = 'SELECT_CHART_TYPE';
export const SELECT_CHART_TICKER = 'SELECT_CHART_TICKER';

// for async data
export const IS_LOADING = 'IS_LOADING';
export const BROKER_FAV_DATA = 'BROKER_FAV_DATA';
export const IS_ERROR = 'IS_ERROR';
// for chart data
export const CHART_DATA = 'CHART_DATA';
export const RELOADED_TIME = 'RELOADED_TIME';



// WEBPACK FOOTER //
// ./src/dalalstreet/src/redux/BrokerFavorites/ActionTypes.ts